var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
  
$('#left-poder-sph').click(function() {
    var_l_sph = $('#4491187617841_option_4').val();
  console.log(var_l_sph); 
  unify_values_l();
  fetch_sku_l();
});


$('#right-poder-sph').click(function() {
    var_r_sph = $('#4491187617841_option_5').val();
  console.log(var_r_sph); 
  unify_values_r();
  fetch_sku_r();
});


function unify_values_l(){
  sku_values_l = var_l_sph ;
  console.log(sku_values_l);
}

function unify_values_r(){
  sku_values_r = var_r_sph;
  console.log(sku_values_r);
}

function check_express() {
  // Parsear exceptions a un array limpio
  const exceptions = (window.ShopifyLc?.exceptions || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  // Revisar si cada ojo está en exceptions (equivale a)
  const l_blocked = sku_values_l ? exceptions.includes(sku_values_l.trim()) : null;
  const r_blocked = sku_values_r ? exceptions.includes(sku_values_r.trim()) : null;

  if ($('#switch1').is(':checked')) {
    // Ambos ojos seleccionados
    if (l_blocked === null && r_blocked === null) {
      // Ninguno seleccionado aún
      $('.lc-express-container, .lc-nostock-container, .lc-step-3, .lc-step-2').hide();
    } else if (l_blocked || r_blocked) {
      // Al menos uno está en exceptions → no disponible
      $('.lc-nostock-container').css('display', 'inline-block');
      $('.lc-express-container').hide();
      $('.lc-step-3, .lc-step-2').hide();
    } else {
      // Ambos disponibles
      $('.lc-express-container').css('display', 'inline-block');
      $('.lc-nostock-container').hide();
      $('.lc-step-3, .lc-step-2').show();
    }
  } else {
    // Solo ojo izquierdo
    if (l_blocked === null) {
      // No seleccionado aún
      $('.lc-express-container, .lc-nostock-container, .lc-step-3, .lc-step-2').hide();
    } else if (l_blocked) {
      // Está en exceptions → no disponible
      $('.lc-nostock-container').css('display', 'inline-block');
      $('.lc-step-3, .lc-step-2').hide();
      $('.lc-express-container').hide();
    } else {
      // Disponible
      $('.lc-express-container').css('display', 'inline-block');
      $('.lc-step-3, .lc-step-2').show();
      $('.lc-nostock-container').hide();
    }
  }
}

$('#switch1').change(function() { check_express(); });

function fetch_sku_l(){
  switch (sku_values_l) {
case '-0.50' : $('#left-sku input').val('BSP80A200'); check_express();  break;
case '-0.75' : $('#left-sku input').val('BSP80A300'); check_express();  break;
case '-1.00' : $('#left-sku input').val('BSP80A400'); check_express();  break;
case '-1.25' : $('#left-sku input').val('BSP80A500'); check_express();  break;
case '-1.50' : $('#left-sku input').val('BSP80A600'); check_express();  break;
case '-1.75' : $('#left-sku input').val('BSP80A700'); check_express();  break;
case '-2.00' : $('#left-sku input').val('BSP80A800'); check_express();  break;
case '-2.25' : $('#left-sku input').val('BSP80B100'); check_express();  break;
case '-2.50' : $('#left-sku input').val('BSP80B200'); check_express();  break;
case '-2.75' : $('#left-sku input').val('BSP80B300'); check_express();  break;
case '-3.00' : $('#left-sku input').val('BSP80B400'); check_express();  break;
case '-3.25' : $('#left-sku input').val('BSP80B500'); check_express();  break;
case '-3.50' : $('#left-sku input').val('BSP80B600'); check_express();  break;
case '-3.75' : $('#left-sku input').val('BSP80B700'); check_express();  break;
case '-4.00' : $('#left-sku input').val('BSP80B800'); check_express();  break;
case '-4.25' : $('#left-sku input').val('BSP80C100'); check_express();  break;
case '-4.50' : $('#left-sku input').val('BSP80C200'); check_express();  break;
case '-4.75' : $('#left-sku input').val('BSP80C300'); check_express();  break;
case '-5.00' : $('#left-sku input').val('BSP80C400'); check_express();  break;
case '-5.25' : $('#left-sku input').val('BSP80C500'); check_express();  break;
case '-5.50' : $('#left-sku input').val('BSP80C600'); check_express();  break;
case '-5.75' : $('#left-sku input').val('BSP80C700'); check_express();  break;
case '-6.00' : $('#left-sku input').val('BSP80C800'); check_express();  break;
case '-6.50' : $('#left-sku input').val('BSP80D200'); check_express();  break;
case '-7.00' : $('#left-sku input').val('BSP80D400'); check_express();  break;
case '-7.50' : $('#left-sku input').val('BSP80D600'); check_express();  break;
case '-8.00' : $('#left-sku input').val('BSP80D800'); check_express();  break;
case '-8.50' : $('#left-sku input').val('BSP80E200'); check_express();  break;
case '-9.00' : $('#left-sku input').val('BSP80E400'); check_express();  break;
case '-9.50' : $('#left-sku input').val('BSP80E600'); check_express();  break;
case '-10.00' : $('#left-sku input').val('BSP80E800'); check_express();  break;
case '-10.50' : $('#left-sku input').val('BSP80F200'); check_express();  break;
case '-11.00' : $('#left-sku input').val('BSP80F400'); check_express();  break;
case '-11.50' : $('#left-sku input').val('BSP80F600'); check_express();  break;
case '-12.00' : $('#left-sku input').val('BSP80F800'); check_express();  break;
case '+1.00' : $('#left-sku input').val('BSP81A400'); check_express();  break;
case '+1.25' : $('#left-sku input').val('BSP81A500'); check_express();  break;
case '+1.50' : $('#left-sku input').val('BSP81A600'); check_express();  break;
case '+1.75' : $('#left-sku input').val('BSP81A700'); check_express();  break;
case '+2.00' : $('#left-sku input').val('BSP81A800'); check_express();  break;
case '+2.25' : $('#left-sku input').val('BSP81B100'); check_express();  break;
case '+2.50' : $('#left-sku input').val('BSP81B200'); check_express();  break;
case '+2.75' : $('#left-sku input').val('BSP81B300'); check_express();  break;
case '+3.00' : $('#left-sku input').val('BSP81B400'); check_express();  break;
case '+3.25' : $('#left-sku input').val('BSP81B500'); check_express();  break;
case '+3.50' : $('#left-sku input').val('BSP81B600'); check_express();  break;
case '+3.75' : $('#left-sku input').val('BSP81B700'); check_express();  break;
case '+4.00' : $('#left-sku input').val('BSP81B800'); check_express();  break;
case '+4.25' : $('#left-sku input').val('BSP81C100'); check_express();  break;
case '+4.50' : $('#left-sku input').val('BSP81C200'); check_express();  break;
case '+4.75' : $('#left-sku input').val('BSP81C300'); check_express();  break;
case '+5.00' : $('#left-sku input').val('BSP81C400'); check_express();  break;


      default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()



function fetch_sku_r(){
  switch (sku_values_r) {

case '-0.50' : $('#right-sku input').val('BSP80A200'); check_express();  break;
case '-0.75' : $('#right-sku input').val('BSP80A300'); check_express();  break;
case '-1.00' : $('#right-sku input').val('BSP80A400'); check_express();  break;
case '-1.25' : $('#right-sku input').val('BSP80A500'); check_express();  break;
case '-1.50' : $('#right-sku input').val('BSP80A600'); check_express();  break;
case '-1.75' : $('#right-sku input').val('BSP80A700'); check_express();  break;
case '-2.00' : $('#right-sku input').val('BSP80A800'); check_express();  break;
case '-2.25' : $('#right-sku input').val('BSP80B100'); check_express();  break;
case '-2.50' : $('#right-sku input').val('BSP80B200'); check_express();  break;
case '-2.75' : $('#right-sku input').val('BSP80B300'); check_express();  break;
case '-3.00' : $('#right-sku input').val('BSP80B400'); check_express();  break;
case '-3.25' : $('#right-sku input').val('BSP80B500'); check_express();  break;
case '-3.50' : $('#right-sku input').val('BSP80B600'); check_express();  break;
case '-3.75' : $('#right-sku input').val('BSP80B700'); check_express();  break;
case '-4.00' : $('#right-sku input').val('BSP80B800'); check_express();  break;
case '-4.25' : $('#right-sku input').val('BSP80C100'); check_express();  break;
case '-4.50' : $('#right-sku input').val('BSP80C200'); check_express();  break;
case '-4.75' : $('#right-sku input').val('BSP80C300'); check_express();  break;
case '-5.00' : $('#right-sku input').val('BSP80C400'); check_express();  break;
case '-5.25' : $('#right-sku input').val('BSP80C500'); check_express();  break;
case '-5.50' : $('#right-sku input').val('BSP80C600'); check_express();  break;
case '-5.75' : $('#right-sku input').val('BSP80C700'); check_express();  break;
case '-6.00' : $('#right-sku input').val('BSP80C800'); check_express();  break;
case '-6.50' : $('#right-sku input').val('BSP80D200'); check_express();  break;
case '-7.00' : $('#right-sku input').val('BSP80D400'); check_express();  break;
case '-7.50' : $('#right-sku input').val('BSP80D600'); check_express();  break;
case '-8.00' : $('#right-sku input').val('BSP80D800'); check_express();  break;
case '-8.50' : $('#right-sku input').val('BSP80E200'); check_express();  break;
case '-9.00' : $('#right-sku input').val('BSP80E400'); check_express();  break;
case '-9.50' : $('#right-sku input').val('BSP80E600'); check_express();  break;
case '-10.00' : $('#right-sku input').val('BSP80E800'); check_express();  break;
case '-10.50' : $('#right-sku input').val('BSP80F200'); check_express();  break;
case '-11.00' : $('#right-sku input').val('BSP80F400'); check_express();  break;
case '-11.50' : $('#right-sku input').val('BSP80F600'); check_express();  break;
case '-12.00' : $('#right-sku input').val('BSP80F800'); check_express();  break;
case '+1.00' : $('#right-sku input').val('BSP81A400'); check_express();  break;
case '+1.25' : $('#right-sku input').val('BSP81A500'); check_express();  break;
case '+1.50' : $('#right-sku input').val('BSP81A600'); check_express();  break;
case '+1.75' : $('#right-sku input').val('BSP81A700'); check_express();  break;
case '+2.00' : $('#right-sku input').val('BSP81A800'); check_express();  break;
case '+2.25' : $('#right-sku input').val('BSP81B100'); check_express();  break;
case '+2.50' : $('#right-sku input').val('BSP81B200'); check_express();  break;
case '+2.75' : $('#right-sku input').val('BSP81B300'); check_express();  break;
case '+3.00' : $('#right-sku input').val('BSP81B400'); check_express();  break;
case '+3.25' : $('#right-sku input').val('BSP81B500'); check_express();  break;
case '+3.50' : $('#right-sku input').val('BSP81B600'); check_express();  break;
case '+3.75' : $('#right-sku input').val('BSP81B700'); check_express();  break;
case '+4.00' : $('#right-sku input').val('BSP81B800'); check_express();  break;
case '+4.25' : $('#right-sku input').val('BSP81C100'); check_express();  break;
case '+4.50' : $('#right-sku input').val('BSP81C200'); check_express();  break;
case '+4.75' : $('#right-sku input').val('BSP81C300'); check_express();  break;
case '+5.00' : $('#right-sku input').val('BSP81C400'); check_express();  break;


default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()
